export default __webpack_public_path__ + "static/media/pin-typ-selected.0714c0c0.svg";